var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getText, getJSON, getCurrentLanguage, } from '@storebrand-digital/fms-translations';
import Tip from '../Tip';
import Description from '../Description';
import Categories from '../Categories';
import Email from '../../../../components/Email';
import { ModalWithTitle } from '../../../../components/Context';
import NavigationTip from '../NavTip';
import { clearCreateMessageThread, getCustomerInfoRequested, } from '../../redux/threadSlice';
function getLevelsFromUrl(searchParams, categoryList) {
    var _a, _b;
    var level1 = categoryList.find(function (category) { return category.name === searchParams.get('level1'); });
    var level2 = (_a = level1 === null || level1 === void 0 ? void 0 : level1.categories) === null || _a === void 0 ? void 0 : _a.find(function (category) { return category.name === searchParams.get('level2'); });
    var level3 = (_b = level2 === null || level2 === void 0 ? void 0 : level2.categories) === null || _b === void 0 ? void 0 : _b.find(function (category) { return category.name === searchParams.get('level3'); });
    var levelsFromUrl = [level1, level2, level3];
    return levelsFromUrl.filter(function (level) { return level !== undefined; });
}
function Content() {
    var _a;
    var search = useLocation().search;
    var searchParams = useSearchParams()[0];
    var language = getCurrentLanguage();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var categoryList = getJSON('categoryList');
    var categoryMap = getJSON('category.map');
    var categoryFromUrl = getJSON("category.".concat(searchParams.get('queue')));
    var _b = useState(true), showTip = _b[0], setShowTip = _b[1];
    var _c = useState(true), showEmail = _c[0], setShowEmail = _c[1];
    var _d = useState(false), confirmClose = _d[0], setConfirmClose = _d[1];
    var _e = useState([]), levelsFromUrl = _e[0], setLevelsFromUrl = _e[1];
    var _f = useState([]), levels = _f[0], setLevels = _f[1];
    var remaining = levels.reduce(function (acc, current) {
        var category = acc.find(function (value) { return value.name === current.name; });
        return category.categories ? category.categories : category;
    }, categoryList);
    var _g = useSelector(function (state) { return state.messageThreads; }), email = _g.email, _h = _g.createMessageThreadState, loading = _h.loading, success = _h.success;
    var onBackClick = function () {
        var updatedLevels = levels.slice(0, -1);
        setLevels(updatedLevels);
    };
    useEffect(function () {
        var levelsUrl = getLevelsFromUrl(searchParams, categoryList);
        if (levelsUrl.length > 0) {
            setLevelsFromUrl(levelsUrl);
            setLevels(levelsUrl);
        }
    }, [categoryList]);
    useEffect(function () {
        if (email === undefined) {
            dispatch(getCustomerInfoRequested());
        }
    }, []);
    var closeModal = function () {
        dispatch(clearCreateMessageThread());
        navigate("/meldinger/".concat(search));
    };
    var onModalClose = function () {
        if (success ||
            remaining.length > 0 ||
            (remaining.tip && showTip) ||
            (remaining.navTip && showTip) ||
            (!(remaining instanceof Array) && email === '' && showEmail)) {
            closeModal();
        }
        else {
            setConfirmClose(true);
        }
    };
    var getModalTitle = function () {
        if (loading) {
            return getText('compose.loading.title');
        }
        var lang = language === 'nb' ? 'no' : language;
        if (success) {
            return getText('compose.sent.title');
        }
        if (categoryFromUrl.secureMessageDescription) {
            return categoryFromUrl.secureMessageDescription[lang];
        }
        if (!(remaining instanceof Array)) {
            return remaining.label[lang];
        }
        return getText('compose.heading');
    };
    var getCurrentCategory = function () {
        var level = levels[levels.length - 1];
        return level && categoryMap[level.name];
    };
    function getPayload() {
        var _a, _b, _c;
        var lang = language === 'nb' ? 'no' : language;
        if (categoryFromUrl.fscPayload) {
            return __assign({ secureMessageDescription: categoryFromUrl.secureMessageDescription[lang] }, categoryFromUrl.fscPayload);
        }
        return __assign(__assign(__assign({ category: getCurrentCategory(), secureMessageDescription: "".concat(levels[0].label[lang], " - ").concat(levels[2] ? levels[2].label[lang] : levels[1].label[lang]) }, (_a = levels[0]) === null || _a === void 0 ? void 0 : _a.fscPayload), (_b = levels[1]) === null || _b === void 0 ? void 0 : _b.fscPayload), (_c = levels[2]) === null || _c === void 0 ? void 0 : _c.fscPayload);
    }
    var trackId = (_a = levels[levels.length - 1]) === null || _a === void 0 ? void 0 : _a.trackId;
    var renderModalContent = function () {
        if (remaining.tip && !remaining.navTip && showTip) {
            return (React.createElement(Tip, { tip: remaining.tip, label: getModalTitle(), trackId: trackId, initialOpen: remaining.openTipTitleNo, setShowTip: setShowTip, onBackClick: levels.length !== levelsFromUrl.length ? onBackClick : undefined }));
        }
        if (remaining.navTip && showTip) {
            return (React.createElement(NavigationTip, { navTip: remaining.navTip, label: getModalTitle(), trackId: trackId, onBackClick: levels.length !== levelsFromUrl.length ? onBackClick : undefined }));
        }
        if (!(remaining instanceof Array) && email === '' && showEmail) {
            return React.createElement(Email, { setShowEmail: setShowEmail, label: getModalTitle() });
        }
        if (!(remaining instanceof Array) || categoryFromUrl.fscPayload) {
            return (React.createElement(Description, { payload: getPayload(), confirmClose: confirmClose, trackId: trackId, setConfirmClose: setConfirmClose, closeModal: closeModal, label: getModalTitle() }));
        }
        return (React.createElement(Categories, { remaining: remaining, levels: levels, dataTrackId: trackId, setLevels: setLevels, onBackClick: levels.length !== levelsFromUrl.length ? onBackClick : undefined }));
    };
    return (React.createElement(ModalWithTitle, { onClose: onModalClose, trigger: undefined, open: false, content: renderModalContent() }));
}
export default Content;
